import { Button } from "@loot-os/ui/components/button";
import { Input } from "@loot-os/ui/components/input";
import { Label } from "@loot-os/ui/components/label";
import { Link, Navigate } from "@tanstack/react-router";
import { useState } from "react";

import { AuthPageLayout } from "../components/AuthPageLayout";
import { useSessionQuery, useSignInMutation } from "../lib/authQueries";

export function LoginPage() {
  const { data: session } = useSessionQuery();
  const signIn = useSignInMutation();
  const [signedIn, setSignedIn] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  // Only after our own sign-in, so sign-out (which lands here before its refresh) never bounces back.
  if (signedIn && session) return <Navigate to="/" replace />;

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true);
    try {
      // Resolves once the session is cached, so the redirect cannot race the AppLayout guard.
      await signIn.mutateAsync({ email, password });
      setSignedIn(true);
    } catch {
      // The query client has already toasted the failure.
      setBusy(false);
    }
  };

  return (
    <AuthPageLayout>
      <form onSubmit={submit} className="grid gap-4">
        <div className="grid gap-2">
          <Label htmlFor="login-email">Email</Label>
          <Input
            id="login-email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div className="grid gap-2">
          <Label htmlFor="login-password">Password</Label>
          <Input
            id="login-password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            minLength={8}
            required
          />
          <Link
            to="/forgot-password"
            className="justify-self-end text-sm text-muted-foreground underline-offset-4 hover:text-foreground hover:underline"
          >
            Forgot password?
          </Link>
        </div>
        <Button type="submit" className="w-full" disabled={busy}>
          {busy ? "Signing in…" : "Sign in"}
        </Button>
      </form>
    </AuthPageLayout>
  );
}
